import { useQuery } from "@tanstack/react-query"

import { bffApi } from "@/queries/apiClient"
import formatStartDate from "@/queries/helpers/formatStartDate"
import queryKeys from "@/queries/queryKeys"

type Banner = {
  text: string
  isMySkiStarDeal: boolean
}

interface UseBannersOptions {
  resortExternalId: number
  startDate: Date
}

const useBannersQuery = (options: UseBannersOptions) => {
  const { resortExternalId, startDate } = options

  const formattedDate = formatStartDate(startDate)

  return useQuery<Banner[]>({
    queryKey: queryKeys.banners(resortExternalId, formattedDate),
    queryFn: async () => {
      const res = await bffApi.get<{ banners: Banner[] }>("/banners", {
        params: {
          externalResortId: resortExternalId,
          arrivalDate: formattedDate,
        },
      })
      return res.data.banners
    },
  })
}

export default useBannersQuery
